import React from 'react'

export default function SectionLabel({ title, count }) {
  return (
    <div className="mono" style={{ display: 'flex', alignItems: 'center', gap: 14, paddingBottom: 16, borderBottom: '1px solid var(--line-soft)' }}>
      <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 3, flexShrink: 0 }}>
        <span style={{ width: 18, height: 2, background: 'var(--accent)', borderRadius: 1 }} />
        <span style={{ width: 12, height: 2, background: 'var(--accent)', opacity: 0.5, borderRadius: 1 }} />
      </span>
      <span style={{ flex: 1, color: 'var(--fg-1)', fontSize: 14, fontWeight: 500, letterSpacing: '0.04em' }}>{title}</span>
      {count && <span style={{ color: 'var(--fg-3)', fontSize: 13 }}>{count}</span>}
    </div>
  )
}
